import { inject, observer } from 'mobx-react';
import { Card, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { URL_CLIENT_VIEW } from 'lib/router/url';
import { ClientShortSearchView, ClientStore } from '../store/clientStore';

export interface ClientSearchByNameResultProps {
  clientStore?: ClientStore,
}

const ClientSearchByNameResult = inject('clientStore')(observer((props: ClientSearchByNameResultProps) => {
  const { clientStore } = props;

  const {
    clientsFoundByName,
  } = clientStore;

  return clientsFoundByName !== null ? (
    <Card>
      <Card.Header>
        <Card.Title>
        Найденные клиенты
        </Card.Title>
      </Card.Header>
      <Card.Body>
        <ListGroup variant='flush'>
          { clientsFoundByName.length > 0 ? (
            <>
              { clientsFoundByName.map((client: ClientShortSearchView) => (
                <Link
                  to={ `${ URL_CLIENT_VIEW }/${ client.clientId }` }
                  key={ client.clientId }
                  style={ { textDecoration: 'none' } }
                >
                  <ListGroup.Item action>
                    { client.fullName }
                  </ListGroup.Item>
                </Link>
              )) }
            </>
          )
            : (
              <h5>Никого не нашлось</h5>
            ) }
        </ListGroup>
      </Card.Body>
    </Card>
  ) : null;
}));

export { ClientSearchByNameResult };
